// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__zcSRB","rootCenter":"LoadMoreObserver_rootCenter__10S_P","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2jHrd"};